import { useEffect, useState } from 'react';
import useOnFetch from './useOnFetch';

export const reverseGeocode = async (lat, lng, fetch) => {
    if (!lat) return null;

    try {
        const { data } = await fetch({
            url: '/locations/geocode',
            method: 'get',
            params: { lat, lng },
        });

        const placeName = data.place?.text;
        if (placeName) {
            return placeName; // async automatically wraps this
        } else {
            console.error('No place found for the given coordinates.');
            return null;
        }
    } catch (error) {
        console.error('No place found for the given coordinates.', error);
        return null;
    }
};

function useGeoCodeLocation({ lat, long }) {
    const fetch = useOnFetch();
    const [location, setLocation] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!lat && !long) return;

        const fetchLocation = async () => {
            setLoading(true);
            const result = await reverseGeocode(lat, long, fetch);
            setLocation(result || 'Unknown location');
            setLoading(false);
        };

        fetchLocation();
    }, [lat, long, fetch]);
    return { location, loading };
}

export default useGeoCodeLocation;
